import {
  Routes,
  Route,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";


import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import DashboardLayout from "./Component/DashboardLayout";
import ScrollToTop from "./ScrollToTop";
import LoginPage from "./Component/Login";
import Register from "./Component/register";

import ProtectedRoute from "./Component/ProtectedRoute";
import PublicRoute from "./Component/PublicRoute";

import AdminHome from "./Component/Admin/adminHome";

import Users from "./Component/Admin/user";
import AdminwalletDetails from "./Component/Admin/adminUserWalletDetails";
import ActiveUsers from "./Component/Admin/adminActiveUsers";
import AdmintodayRegistered from "./Component/Admin/admintodayRegistered";
import UserViewProfile from "./Component/Admin/userViewProfile";
import PendingFundRequest from "./Component/Admin/pendingFundRequest";
import AdminBanklist from "./Component/Admin/adminBanklist";

import FundManagementsendUser from "./Component/Admin/FundManagementsendUser";
import FundRequestView from "./Component/Admin/FundRequestview";
import ApprovedFundRequest from "./Component/Admin/approvedFundRequest";
import FundTransferList from "./Component/Admin/fundTransferList";
import RejectedFundRequest from "./Component/Admin/rejectedFundRequest";


import AddGallery from "./Component/Admin/addGallery";
import Gallery from "./Component/Admin/gallery";


import AdminIncomeReports from "./Component/Admin/adminIncomeReports";

import LuckyDraws from "./Component/Admin/luckydraw";
import AddLuckydraw from "./Component/Admin/AddLuckydraw";


import AdminProfile from "./Component/Admin/adminProfile";

import Projects from "./Component/Admin/projects";
import AddProject from "./Component/Admin/addProject";
import EditProjectlist from "./Component/Admin/editProject";



import UserHome from "./Component/user/userHome";
import UserProfile from "./Component/user/userProfile";
import UserLuckyDraw from "./Component/user/userLuckydraw";


import UserSupport from "./Component/user/userSupport";

import Wallet from "./Component/Admin/wallet";

// submenu
import UserMyteam from "./Component/user/userMyteam";

import UserFundRequest from "./Component/user/userFundRequest";

import UserWallet from "./Component/user/wallet";
import BankAccount from "./Component/user/bankaccount";
import UserWithdrawal from "./Component/user/userWithdrawal";
import AddSites from "./Component/Admin/addSites";
import Sites from "./Component/Admin/sites";
import EditSiteDetails from "./Component/Admin/editSite";


function App() {

  return (
    <>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
      <ScrollToTop />

      <Routes>
        <Route element={<PublicRoute />}>

          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />

        </Route>

        <Route element={<ProtectedRoute />}>

          <Route path="/admin" element={<DashboardLayout />}>

            <Route path="home" element={<AdminHome />} />

            {/* users */}
            <Route path="users" element={<Users />} />
            <Route path="user-profile/:id" element={<UserViewProfile />} />
            <Route path="wallet" element={<AdminwalletDetails />} />
            <Route path="user-wallet/:id" element={<Wallet />} />
            <Route path="activeusers" element={<ActiveUsers />} />
            <Route path="todayregistered" element={<AdmintodayRegistered />} />

            <Route path="profile" element={<AdminProfile />} />

            <Route path="widthraw-request" element={<PendingFundRequest />} />
            <Route path="bank-account-approval" element={<AdminBanklist />} />


            {/* fund-management */}

            <Route path="send-fund" element={<FundManagementsendUser />} />
            <Route path="pending-request" element={<FundRequestView />} />
            <Route path="approved-request" element={<ApprovedFundRequest />} />
            <Route path="rejected-request" element={<RejectedFundRequest />} />
            <Route path="transfer-list" element={<FundTransferList />} />
            <Route path="add-gallery" element={<AddGallery />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="lucky-draw" element={<LuckyDraws />} />
            <Route path="add-luckydraw" element={<AddLuckydraw />} />
            <Route path="totalincomereport" element={<AdminIncomeReports />} />


            <Route path="projects" element={<Projects />} />
            <Route path="project-add" element={<AddProject />} />
            <Route path="project-edit/:id" element={<EditProjectlist />} />
            <Route path="add-site" element={<AddSites />} />
            <Route path="sites/:id" element={<Sites />} />
            <Route path="edit-site/:id" element={<EditSiteDetails />} />



          </Route>

          {/* user  */}

          <Route path="/user" element={<DashboardLayout />}>

            <Route path="home" element={<UserHome />} />
            <Route path="profile" element={<UserProfile />} />
            <Route path="userluckydraw" element={<UserLuckyDraw />} />

            <Route path="myteam" element={<UserMyteam />} />
            <Route path="fundrequest" element={<UserFundRequest />} />
            <Route path="wallet" element={<UserWallet />} />
            <Route path="withdraw" element={<UserWithdrawal />} />

            <Route path="support" element={<UserSupport />} />
            <Route path="bankaccount" element={<BankAccount />} />



          </Route>

        </Route>

      </Routes>
    </>

  );
}

export default App;